var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFormsIconNew = function SvgFormsIconNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6CFF",
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M5 6.405a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6CFF",
    d: "M8.218 6.405H18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M8.218 6.405H18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6CFF",
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M5 10.804a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6CFF",
    d: "M8.218 10.804H18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M8.218 10.804H18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6CFF",
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M5 15.203a.405.405 0 1 0 .81 0 .405.405 0 0 0-.81 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6CFF",
    d: "M8.218 15.203H18Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6C6CFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M8.218 15.203H18"
  })));
};
export default SvgFormsIconNew;